const lbsMapNavigate = function ({address, latitude_loc, longitude_loc}) {
	const url = `https://apis.map.qq.com/tools/routeplan/eword=${address}&epointx=${latitude_loc}&epointy=${longitude_loc}?referer=eccs&key=4LFBZ-C6VR4-UJLUP-XDWVV-5PFWJ-QCB3D`
	window.location.href = url
}
export default {
	lbsMapNavigate
}
